module.exports = __webpack_public_path__ + "img/unselected.d36436e3.svg";